<template>
  <Modal v-if="showModalAddComment" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="addComment">
      <div class="addComment__header">
        <span class="title">{{ $t('addComment') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="addComment__body">
        <FormKit
          id="comment-form"
          v-model="formData"
          type="form"
          :actions="false"
          @submit="submitHandler"
        >
          <label class="label-comment" for="comment">
            {{ $t('comment') }}
          </label>
          <textarea
            id="comment"
            v-model="formData.comment"
            class="input-comment"
            maxlength="250"
          >
          </textarea>
        </FormKit>
      </div>
      <div class="addComment__buttons">
        <Button variant="filled" :title="$t('save')" @click="saveComment" />
        <Button
          variant="notBordered"
          :title="$t('cancel')"
          @click="$emit('closeModal')"
        />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'AddComment',
  props: ['showModalAddComment', 'activePayment'],
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      formData: {
        comment: ''
      }
    };
  },
  methods: {
    ...mapActions('orders', ['addComment']),
    async submitHandler() {
      this.loading = true;

      const orderId = this.activePayment?.id;
      const payload = { comment: this.formData.comment };

      await this.addComment({
        data: payload,
        orderId
      });

      this.loading = false;

      this.$emit('closeModal');
    },
    saveComment() {
      this.$formkit.submit('comment-form');
    }
  },
  watch: {
    showModalAddComment() {
      if (this.showModalAddComment) {
        this.formData.comment = this.activePayment.comment;
      }
    }
  }
})
export default class AddComment extends Vue {}
</script>

<style lang="scss" scoped>
.addComment {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .addComment__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .addComment__body {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 24px;
    width: 400px;
    height: 177px;
    label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    textarea {
      width: 366px;
      height: 140px;
      padding: 16px;
      font-size: $fourteenSize;
      border: 1px solid $border;
      border-radius: 8px;
      resize: none;
      &:focus {
        outline: none;
      }
    }
  }
  .addComment__buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>
